import { VINMask, carPlateNumber } from "../../../utils/compare/rcaUtils";

export const carSummaryFields  = (car) => {

    const vin = VINMask(car.serie_sasiu);

    let fields = [
        { label: 'Stare înmatriculare', value: car.tip_inmatriculare.label},
        { label: 'Categorie auto', value: car.subcategorie_auto.denumire},
        { label: 'Serie șasiu', value: vin},
    ];

    let carPlate;
    if (car.tip_inmatriculare.value == 'inmatriculat') {
        carPlate = carPlateNumber(car.nr_inmatriculare);
        fields.push({ label: 'Număr de înmatriculare', value: carPlate});
        fields.push({ label: 'Dată înmatriculare', value: car.data_inmatriculare});
        fields.push({ label: 'Dată expirare ITP', value: car.data_expirare_itp});
    }
    fields.push({ label: 'Număr kilometri', value: car.numar_km});

    let model = `${car.marca_auto.denumire} ${car.model_auto} (${car.an_fabricatie})`;
    fields.push({ label: 'Model', value: model});

    let dateTehnice = `${car.capacitate_cilindrica} cmc, ${car.putere_kw} kW, ${car.combustibil.denumire}, ${car.masa_totala} kg, ${car.nr_locuri} locuri`;
    fields.push({ label: 'Date tehnice', value: dateTehnice});
    fields.push({ label: 'Seria cărții auto (CIV)', value: car.civ});

    if (car.leasing == 'da') {
        fields.push({ label: 'Leasing în derulare', value: 'da'} );
        fields.push({ label: 'Compania de leasing', value: car.leasing_company_id.nume} );
    }

    fields.push({ label: 'Utilizare', value: 'în scop personal'} );

    const description = `${model} ${car.tip_inmatriculare.value == 'inmatriculat' ? carPlate : vin }`;

    return [fields, description];
}

export const ownerSummaryFields = (vehicle) => {
    const {owner, car} = vehicle;

    let fields;
    let ownerType = car.leasing == 'nu' ? 'Proprietar' : 'Utilizator';
    if (owner.tipClient == 'pf') {
        fields = [
            { label: ownerType, value: `${owner.Prenume} ${owner.Nume}`},
            { label: 'CNP', value: owner.CNP},
            { label: 'Act identitate (BI/CI)', value: `${owner.serieCI} ${owner.numarCI}`},
            { label: 'Email', value: owner.Email},
            { label: 'Telefon', value: owner.Telefon},
            { label: 'Permis obținut în', value: owner.anPermis},
        ];
    } else {
        fields = [
            { label: ownerType, value: owner.companie},
            { label: 'CIF', value: owner.cif},
            { label: 'Domeniu de activitate', value: owner.caen.denumire},
            { label: 'Forma juridica', value: owner.categorie_pj.label},
            { label: 'Reprezentant societate', value: `${owner.Prenume} ${owner.Nume}`},
            { label: 'Email', value: owner.Email},
            { label: 'Telefon', value: owner.Telefon},
        ];
    }

    const description = owner.tipClient == 'pf' ? `${owner.Prenume} ${owner.Nume}` : owner.companie;

    return [fields, description];
}

export const addressSummaryFields = (address) => {

    let street = 'Strada ' + address.strada;
    street += address.nrStrada!= '' ? ' nr. '+address.nrStrada : '';
    street += address.bloc!= '' ? ', Bloc '+address.bloc : '';
    street += address.scara!= '' ? ', Scara '+address.scara : '';
    street += address.etaj!= '' ? ', Etaj '+address.etaj : '';
    street += address.apartament!= '' ? ', Ap. '+address.apartament : '';

    const fields = [
        { label: 'Judet', value: address.Judet.name.toUpperCase()},
        { label: 'Localitate', value: address.Localitate.name},
        { label: 'Strada', value: address.Localitate.name},
        { label: 'Adresa', value: street},
        { label: 'Cod poștal', value: address.cod_postal},
    ];

    const description = `Strada ${address.strada}, ${address.Localitate.name}, ${address.Judet.carCode}`;
    return [fields, description];
}

export const driversSummaryFields = (list) => {
    let fields = [];
    let description = '';
    list.forEach( (driver, i) => {
        fields.push({ 
            label: `${driver.prenume} ${driver.nume}`, 
            value: `CNP ${driver.cnp}, CI ${driver.idserie} ${driver.idno}`
        });
        description += i>0 ? ', ' : '';
        description += `${driver.prenume} ${driver.nume}`
    });

    return [fields, description];
}

export const dntSummaryFields = (cerere) => {
    let fields = [
        { label: 'Durata poliței', value: `${cerere.durata} luni`},
        { label: 'Valabilă din', value: `${cerere.dataPolita}`},
    ];
    let description = `Asigurare pe ${cerere.durata} luni, valabilă din ${cerere.dataPolita}`;
    return [fields, description];
}